import { LeftArrowIcon } from '../../assets/icons/icons';
import { triggerImpactHaptic } from '../../assets/utils/hapticFeedback';
import './ScreenHeader.css';

function ScreenHeader({ title, onBack }) {
  if (!onBack) {
    return (
      <header className="screen-header">
        <h1 className="screen-header__title">{title}</h1>
      </header>
    );
  }

  const handleBack = () => {
    triggerImpactHaptic('light');
    onBack();
  };

  return (
    <header className="screen-header">
      <button type="button" className="screen-header__back" onClick={handleBack}>
        <LeftArrowIcon className="screen-header__back-icon" />
        <span className="screen-header__back-title">{title}</span>
      </button>
    </header>
  );
}

export default ScreenHeader;
